import React from 'react';
import {addLocaleData, IntlProvider, injectIntl} from 'react-intl';
import {Glyphicon, Media, OverlayTrigger, Tooltip} from 'react-bootstrap';
import send from './img/send_button.svg';
// import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import {inject, observer} from "mobx-react";
import data from 'emoji-mart/data/facebook.json'
import { NimblePicker as Picker } from 'emoji-mart'


@inject('uiStore') @observer
class Sender extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      text: '',
      renderEmojiPicker: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSendBtnClick = this.handleSendBtnClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleEmojiClick = this.handleEmojiClick.bind(this);
    this.handleEmojiBtnClick = this.handleEmojiBtnClick.bind(this);
    this.hideEmojiPicker = this.hideEmojiPicker.bind(this);
  }

  render(){
    return(

      <div >
        {this.renderEmojiPickerOrInput()}
      </div>

    );
  }

  renderEmojiPickerOrInput(){
      if( this.state.renderEmojiPicker ){
        return (
            <div>
              <Picker set='facebook' data={data} sheetSize={32} emojiSize={24} 
                onClick={this.handleEmojiClick} />
              <div onClick={this.hideEmojiPicker} >

              </div>
            </div>
          );
      }
      else{
        return(
          <div className="sender">
            <span className="emoji-btn"  onClick={this.handleEmojiBtnClick} ><i className="fa fa-smile-o" aria-hidden="true"></i></span>
            <textarea value={this.state.text} 
              onChange={this.handleInputChange}
              onKeyPress={this.handleKeyPress}
              ref={(input) => { this.textInput = input; }}
              rows={2} className="new-message" name="message" placeholder={""}
              autoFocus autoComplete="off" />
            <button className="send" onClick={this.handleSendBtnClick}
              disabled={!this.state.text}>
              <img src={send} className="send-icon" alt="send" />
            </button>
          </div>
        );
      }
  }

  handleInputChange(e){
    this.setState({text: e.target.value});
  }

  handleKeyPress(e){
    if (e.which == 13){      
      if(e.shiftKey){
        //this.setState({text:this.state.text + "\n"});
      }
      else{
        this.setState({text:this.state.text + "\n"});
        //this.handleSendBtnClick();
        e.preventDefault();
      }
    }
  }

  handleSendBtnClick(){
    if( this.state.text.length ){
      this.props.conversation.reply(this.state.text);
      this.props.uiStore.handleNewReply();
      this.setState({text:""});
    }
    this.textInput.focus();
  }

  hideEmojiPicker(){
    this.setState({
      renderEmojiPicker: false,
    });
  }

  handleEmojiClick(e){
    this.setState({text: this.state.text + e.native});
    this.hideEmojiPicker();
  }

  handleEmojiBtnClick(){
    this.setState({
      renderEmojiPicker: true,
    });
  }

}

export default injectIntl(Sender);